/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2024-08-28 13:55:22
 */
/* eslint-disable */
import axios from 'axios'
import { Toast } from 'vant'
import { encodeHttpParams, decodeHttpResult } from '../todayUtils'
import getUA from '../getUA'

const instance = axios.create({
  timeout: 30000
})

const isEnvTest = process.env.NODE_ENV === 'test'
const isEnvProduction = process.env.NODE_ENV === 'production'

if (isEnvProduction) {
  instance.defaults.baseURL = 'https://app.dayscamera.com'
} else if (isEnvTest) {
  instance.defaults.baseURL = 'https://app-test.dayscamera.com'
} else {
  instance.defaults.baseURL = 'https://app-test.dayscamera.com'
}

export const requestInterceptor = instance.interceptors.request.use(
  async (config) => {
    if (!navigator.onLine) {
      // Toast('网络异常')

      return Promise.reject(new Error('网络异常'))
    }

    let params = config.data

    if (isEnvProduction && config.data && getUA().isTodayCamera) {
      params = await encodeHttpParams(config.data)
    }

    return {
      ...config,
      data: params
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const responseInterceptor = instance.interceptors.response.use(
  async (response) => {
    let result = response.data
    let isBase64Decode = false
    // 单个接口配置是否需要base64解密，优先级最大
    if (response.config.isBase64DecodeHttpResult !== undefined) {
      isBase64Decode = response.config.isBase64DecodeHttpResult
    } else {
      // 单个接口没有配置时，根据整个实例是否配置为准
      isBase64Decode = !!instance.isBase64DecodeHttpResult
    }

    if (isEnvProduction && getUA().isTodayCamera) {
      result = await decodeHttpResult(response.data, isBase64Decode)
    }
    return {
      ...response,
      data: result
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance
